export enum CommonType {
    Yes = 'yes',
    No = 'no',
    True = 'true',
    False = 'false',
    Success = 'success',
    Failed = 'failed',
    Other = 'other',
}
